// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "20260917.1789669814/static/js/" + chunkId + "." + {"249":"be971520","463":"e80118b9"}[chunkId] + ".chunk.js";
};